import React, { useContext } from 'react';
import {
  HowUnderarmWork,
  LHRIdealForUnderarm,
  SectionDivider,
  UnderarmHero,
  WaxingCostPerYear,
  SEO,
} from '../../components';
import { GlobalSiteDataContext } from '../../context';
import { graphql } from 'gatsby';
import './areas.css';

function UnderarmPage() {
  const siteData = useContext(GlobalSiteDataContext);
  return (
    <main id='underarm-page'>
      <UnderarmHero />
      <WaxingCostPerYear globalData={siteData.globalData} />
      <HowUnderarmWork />
      <SectionDivider />
      <LHRIdealForUnderarm />
    </main>
  );
}

export const Head = ({ data, location }) => {
  const query = data.siteDataJson;
  return (
    <SEO
      location={location}
      origin={query.origin}
      title={`Underarm Laser Hair Removal | Milan Laser in ${query.name}, ${query.stateAbbrev}`}
      description="Say goodbye to pesky armpit hair by booking an appointment for underarm laser hair removal today. Don't miss out, schedule your consultation today!"
    />
  );
};

export const query = graphql`
  {
    siteDataJson {
      name
      stateAbbrev
      origin
    }
  }
`;

export default UnderarmPage;
